import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { PeriodoAcademicoDTO, VoidPeriodoAcademicoDTO } from "../interfaces/SAAC/PeriodoAcademicoDTO";
import { EstudianteActivoDTO, VoidEstudianteActivoDTO } from "../interfaces/SAAC/EstudianteActivoDTO";
import { MateriaInvestigacionDTO, VoidMateriaInvestigacionDTO } from "../interfaces/SAAC/MateriaDTO";
import { CatalogoProfesor, VoidCatalogoProfesor } from "../interfaces/SAAC/CatalogoProfesor";
const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/Academico';

export default class AcademicoService {
    async GetCarreraActivaByMatricula(token: any,matricula: string,tipo: string): Promise<ResponceApi<EstudianteActivoDTO>> {
        try {
            const response1: AxiosResponse<ResponceApi<EstudianteActivoDTO>> = await axios.get(localBack + APICATALOGO + '/GetCarreraActivaByMatricula/'+matricula+'&'+tipo,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetCarreraActivaByMatricula'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidEstudianteActivoDTO(),
            };
        }
    }

    async GetPeriodoAcademicoEnEjecucion(token: any): Promise<ResponceApi<PeriodoAcademicoDTO>> {
        try {
            const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/GetPeriodoAcademicoEnEjecucion',
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetPeriodoAcademicoEnEjecucion'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidPeriodoAcademicoDTO(),
            };
        }
    }

    async GetMateriaInvestigacionAp(token: any, matricula: string): Promise<ResponceApi<MateriaInvestigacionDTO>> {
        try {
            const response1: AxiosResponse<ResponceApi<MateriaInvestigacionDTO>> = await axios.get(localBack + APICATALOGO + '/GetMateriaInvestigacionAp/'+matricula,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetPeriodoAcademicoEnEjecucion'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidMateriaInvestigacionDTO(),
            };
        }
    }

    async GetCatalogoProfesores(token: any, idperiodo: number, idproyecto: number, tipo: string): Promise<ResponceApi<CatalogoProfesor>> {
        try {
            const response1: AxiosResponse<ResponceApi<CatalogoProfesor>> = await axios.get(localBack + APICATALOGO + '/GetCatalogoProfesores/'+idperiodo+'&'+idproyecto+'&'+tipo,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetCatalogoProfesores'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidCatalogoProfesor(),
            };
        }
    }
}